import { Link } from "react-router-dom";
import ImgPlaceholder from "../../../assets/ImgPlaceholder.svg"

const StudentProgressRow = ({
    fullName,
    studentId,
    progress,
    videosWatched,
    totalVideos,
}: {
    fullName: string;
    studentId: string;
    progress: number;
    totalVideos: number;
    videosWatched: number;
}) => {
    return (
        <tr>
            <td className="px-2 first:pl-5 last:pr-5 w-[30%] py-3 whitespace-nowrap">
                <Link className="w-full" to={`/dashboard/students/${studentId}`}>
                    <div className="rounded-full text-left py-0.5 text-sm font-semibold flex items-center gap-4">
                        <img className="w-11 h-11 rounded-full object-cover" src={ImgPlaceholder} alt="Student" />
                        {fullName}
                    </div>
                </Link>
            </td>
            <td className="px-2 first:pl-5 last:pr-5 w-[70%] py-3 whitespace-nowrap">
                <div className="flex gap-4 items-center rounded-full text-left py-0.5 text-sm font-semibold">
                    <div>
                        <div className="w-[500px] h-2.5 rounded-[30px] bg-[#D9D9D9] relative overflow-hidden">
                            <div
                                style={{ width: `${progress || 0}%` }}
                                className="bg-primary h-full"
                            />
                        </div>
                        <p className="h-0">
                            {progress.toFixed(2)}%
                        </p>
                    </div>
                    <h1>Videos Watched: {videosWatched} of {totalVideos}</h1>
                </div>
            </td>
        </tr>
    );
};

export default StudentProgressRow;
